module.exports = __webpack_public_path__ + "img/Infrect-predictor.503d69c7.svg";